var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-enter-tips-audio-with-out-btn-mute"},[_c('shared-animated-icon-mute')],1)}
var staticRenderFns = []

export { render, staticRenderFns }